import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BlockItem, AppState } from '../../utils/types'
import { getQueryStringValue, setQueryStringValue } from '../../utils/queryString';
import qs from "query-string";

let defaultConfig = {
    "appId": "",
    "perPage": "8",
    "appHeading": null,
    "appDescription": null,
};

const pageConfig = (window as any).filterBlock != undefined ? (window as any).filterBlock : defaultConfig;
const pageSize = (window as any).filterBlock != undefined ? parseInt(pageConfig.perPage) : parseInt(defaultConfig.perPage);

const initialState: AppState = {
    items: [],
    filteredItems: [],
    selectedTag: 'all',
    currentPage: 1,
    appId: pageConfig.appId,
    perPage: pageSize,
    appHeading: pageConfig.appHeading || null,
    appDescription: pageConfig.appDescription || null,
};

const removeQueryParameter = (key: string) => {
    const values = qs.parse(window.location.search);
    delete values[key];
    const newQsValue = qs.stringify(values);
    const newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        (newQsValue ? `?${newQsValue}` : '');
    window.history.pushState({ path: newurl }, "", newurl);
};

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setItems: (state, action: PayloadAction<BlockItem[]>) => {
            state.items = action.payload;
            state.filteredItems = action.payload;
        },
        initializeFromWindow: (state) => {
            const windowItems = (window as any).filterBlock.items || [];
            state.items = windowItems;
            
            // Check for tag query parameter
            const tagFromUrl = getQueryStringValue('tag');
            if (tagFromUrl && typeof tagFromUrl === 'string') {
                state.selectedTag = tagFromUrl;
                // Filter items based on URL tag
                if (tagFromUrl === 'all') {
                    state.filteredItems = windowItems;
                } else {
                    state.filteredItems = windowItems.filter((item: BlockItem) =>
                        item.Tags.includes(tagFromUrl)
                    );
                }
            } else {
                state.selectedTag = 'all';
                state.filteredItems = windowItems;
            }
            
            state.currentPage = 1;
        },
        setSelectedTag: (state, action: PayloadAction<string>) => {
            state.selectedTag = action.payload;
            state.currentPage = 1;

            // Update URL - remove parameter if "all" is selected, otherwise set it
            if (action.payload === 'all') {
                removeQueryParameter('tag');
                state.filteredItems = state.items;
            } else {
                setQueryStringValue('tag', action.payload);
                state.filteredItems = state.items.filter(item =>
                    item.Tags.includes(action.payload)
                );
            }
        },
        setCurrentPage: (state, action: PayloadAction<number>) => {
            state.currentPage = action.payload;
        }
    }
});

export const { setItems, initializeFromWindow, setSelectedTag, setCurrentPage } = appSlice.actions;
export default appSlice.reducer;